module.exports = __webpack_public_path__ + "img/grey_circle.1b4abd0e.svg";